<template>
  <button
    class="btn edit-button"
    @click="$emit('click')"
    :title="$t('common.edit')"
    :aria-label="$t('common.edit')"
    type="button"
  >
    <font-awesome-icon icon="fa-pen-to-square" />
  </button>
</template>

<script setup lang="ts">
defineEmits<{
  click: [];
}>();
</script>

<style scoped lang="scss">
.edit-button {
  width: 32px;
  height: 32px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  border-radius: 6px;
  background-color: var(--phoenix-gray-50);
  border: 1px solid var(--phoenix-gray-200);
  color: var(--phoenix-primary);

  &:hover {
    background-color: var(--phoenix-gray-100);
    border-color: var(--phoenix-gray-300);
    color: var(--phoenix-primary-dark);
  }

  &:active {
    background-color: var(--phoenix-gray-200);
    border-color: var(--phoenix-gray-300);
    color: var(--phoenix-primary-darker);
    transform: scale(0.95);
  }

  &:focus {
    box-shadow: 0 0 0 0.25rem rgba(var(--phoenix-primary-rgb), 0.25);
    outline: none;
  }
}
</style>
